const SCENARIO_MENU_RETURN_PATH_KEY = "harmony-scenario-menu-return-path";

export const DEFAULT_SCENARIO_MENU_RETURN_PATH = "/scenarios/all";

const getPathPrefix = (): string =>
  typeof __PATH_PREFIX__ !== "undefined" ? __PATH_PREFIX__ : "";

const stripPathPrefix = (pathname: string): string => {
  const prefix = getPathPrefix().replace(/\/$/, "");

  if (!prefix) {
    return pathname;
  }

  if (pathname === prefix || pathname === `${prefix}/`) {
    return "/";
  }

  if (pathname.startsWith(`${prefix}/`)) {
    return pathname.slice(prefix.length) || "/";
  }

  return pathname;
};

const normalizePath = (pathname: string): string => {
  const path = stripPathPrefix(pathname).replace(/\/$/, "");

  return path || "/";
};

export const isScenarioMenuPath = (pathname: string): boolean => {
  const path = normalizePath(pathname);

  if (path === "/scenarios/all") {
    return true;
  }

  if (/^\/scenarios\/all\/\d+$/.test(path)) {
    return true;
  }

  if (path === "/scenarios/custom-scenario") {
    return true;
  }

  if (path === "/scenarios/saved") {
    return true;
  }

  const segments = path.split("/").filter(Boolean);

  if (segments[0] !== "scenarios" || segments.length < 2) {
    return false;
  }

  const parts = segments.slice(1);

  if (parts.length === 1) {
    return true;
  }

  if (parts.length === 2) {
    if (parts[1] === "all") {
      return true;
    }

    if (/^\d+$/.test(parts[1])) {
      return true;
    }

    return true;
  }

  if (parts.length === 3) {
    if (parts[1] === "all" && /^\d+$/.test(parts[2])) {
      return true;
    }

    if (/^\d+$/.test(parts[2])) {
      return true;
    }
  }

  return false;
};

export const isScenarioPagePath = (pathname: string): boolean => {
  const path = normalizePath(pathname);

  if (path === "/scenarios/custom-scenario/run") {
    return true;
  }

  if (
    /^\/scenarios\/saved\/[^/]+$/.test(path) &&
    path !== "/scenarios/saved/view"
  ) {
    return true;
  }

  const segments = path.split("/").filter(Boolean);

  if (segments[0] !== "scenarios") {
    return false;
  }

  const parts = segments.slice(1);

  if (parts.length === 2 && parts[1] !== "all" && !/^\d+$/.test(parts[1])) {
    return true;
  }

  if (parts.length === 3 && parts[1] !== "all" && !/^\d+$/.test(parts[2])) {
    return true;
  }

  return false;
};

export const captureScenarioMenuReturnPath = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  const path = stripPathPrefix(window.location.pathname);
  const search = window.location.search;

  sessionStorage.setItem(
    SCENARIO_MENU_RETURN_PATH_KEY,
    search ? `${path}${search}` : path,
  );
};

export const clearScenarioMenuReturnPath = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  sessionStorage.removeItem(SCENARIO_MENU_RETURN_PATH_KEY);
};

export const getScenarioMenuReturnPath = (): string => {
  if (typeof window === "undefined") {
    return DEFAULT_SCENARIO_MENU_RETURN_PATH;
  }

  const storedPath = sessionStorage.getItem(SCENARIO_MENU_RETURN_PATH_KEY);

  if (!storedPath) {
    return DEFAULT_SCENARIO_MENU_RETURN_PATH;
  }

  return stripPathPrefix(storedPath);
};
